<template>
  <div class="user-module">
    <div class="main-content">
      <div class="header">
        <span class="title">他们都在用七牛云</span>
        <span class="subtitle">（*排名不分先后顺序）</span>
      </div>
      <div class="user-body">
        <div class="user-box">
          <div class="user-item" v-for="i in 20" :key="i">
            <img
              :src="'https://www-static.qbox.me/sem/pili-live-1001/source/img/user-' + (i - 1) + '.jpg'"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userModule",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.user-module {
  background: #ffffff;
  width: 100%;
  min-width: 1440px;
  display: flex;
  padding: 80px 0 80px 0;
  .main-content {
    // height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .header {
      width: 100%;
      height: 78px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      justify-content: space-between;
      //   margin-bottom: 44px;
      font-family: PingFang SC;
      letter-spacing: 0px;
      .title {
        font-weight: 500;
        line-height: 48px;
      }
      .subtitle {
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
      }
    }
    .user-body {
      width: 100%;
      display: flex;
      .user-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        // flex-direction: row;
        // justify-content: space-between;
        // align-items: center;
        .user-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          &:hover {
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
            transition: 0.3s ease-in-out;
            transform: translateY(-5px) scale(1.1) !important;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .main-content {
      width: 1196px;
      height: 498px;
      .header {
        .title {
          font-size: 36px;
        }
      }
      .user-body {
        height: 397px;
        .user-box {
          .user-item {
            width: 223px;
            height: 83px;
            margin: 8px;
          }
        }
      }
    }
  }
  @media screen and (min-width: 1441px) {
    .main-content {
      width: 1440px;
      height: 582px;
      .header {
        .title {
          font-size: 40px;
        }
      }
      .user-body {
        height: 480px;
        .user-box {
          .user-item {
            width: 268px;
            height: 100px;
            margin: 10px;
          }
        }
      }
    }
  }
}
</style>